import Config from "@/const/Config";
import { BaseApi } from "@/api/BaseApi";
import { SyozokuWithKisokus } from "@/types/SyuugyouKisoku";

export class SyuugyouKisokuApi extends BaseApi {
  /**
   * 所属に応じた就業規則一覧を取得します（オプション値）
   * @returns SyuugyouKisokuOptions 所属に応じた就業規則（権限によりシステム上のすべての就業規則）
   */
  public async getKisokuOptionsBySyozoku() {
    try {
      const res = await this.get<SyozokuWithKisokus[]>(Config.API_URL + '/syuugyou_kisoku/syozoku')
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  public async getKisokuPdf(path: string) {
    try {
      const res = await this.post<string>(Config.API_URL + '/syuugyou_kisoku/detail', {path: path})
      return res.data
    } catch (e: any) {
      throw e
    }
  }
}
